// app/components/jobseekerModalContent.jsx
import SocialIcons from '../components/socialIcons'
import { Link } from '@remix-run/react'

const JobseekerModalContent = () => {
  return (
    <div className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 p-4">
        <h2 className="text-headline lg:text-display-md font-bold lg:mb-6">WE ARE WAITING TO HEAR FROM YOU!</h2>
        <div className="hidden lg:flex space-x-4 mb-6">
          <SocialIcons iconColor="text-pointed" iconHover="" iconSize="" />
        </div>
      </div>
      <div className="w-full lg:w-1/2 p-4">
        <p className="text-body font-bold">We invite you to join our Talent Platform.</p>
        <p className="text-body mt-4">
          Recruitment through TalentLift is entirely led by our employer partners. If a job opportunity matches your
          skills, TalentLift will contact you to collect further information or to develop your CV. If we have not
          received any opportunities from employers that match your qualifications, we may not yet contact you. To learn
          more about how TalentLift works, please visit our{' '}
          <Link to="/eligibility/#faq" target="_blank" className="tl-link">
            frequently asked questions
          </Link>{' '}
          or our{' '}
          <Link
            to="https://drive.google.com/file/d/19xUEpNzGLRNBWXRZxV9B-OS_8Z_WgJAR/view"
            className="tl-link"
            target="_blank"
          >
            job seeker journey map
          </Link>
          .
        </p>
        <div className="flex justify-end">
          <a href="https://platform.talentlift.ca" target="_blank">
            <button className="w-full py-3 px-6 bg-gradient-to-r from-gradient2 to-gradient2_80 hover:from-gradient2_80 hover:to-gradient2_80 text-white rounded-full mt-4">
              JOIN TALENT PLATFORM
            </button>
          </a>
        </div>
      </div>
    </div>
  )
}

export default JobseekerModalContent
